export default function (index, enumClass) {
    return enumClass[index]
}
